import { GlButton, GlModalDirective, GlTooltipDirective } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { formType } from '~/boards/constants';
import { s__ } from '~/locale';
import Tracking from '../../tracking/index.js?vue3';
export default {
    name: 'ConfigToggle',
    components: {
        GlButton
    },
    directives: {
        GlModalDirective,
        GlTooltipDirective
    },
    mixins: [
        Tracking.mixin()
    ],
    inject: [
        'canAdminList'
    ],
    emits: [
        'show-board-modal'
    ],
    computed: {
        buttonText () {
            return this.canAdminList ? s__('Boards|Configure board') : s__('Boards|Board configuration');
        }
    },
    methods: {
        showPage () {
            this.track('click_button', {
                label: 'edit_board'
            });
            this.$emit('show-board-modal', formType.edit);
        }
    }
};
